import React, { useEffect, useState } from "react";
import { AdminContainer } from "../../components/layouts";
import { Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import api from "../../api";
import { VerificationSwitch } from "./ components/VerificationSwitch";
import { toast } from "react-toastify";
import { VerificationStatusBadge } from "./ components/VerificationStatusBadge";
import { JsonEditor } from "json-edit-react";

import { Button, Drawer, Box, TextField } from "@mui/material";

export const VerificationIdPage = () => {
  const { verificationId } = useParams();
  const [verification, setVerification] = useState(null);
  const [loading, setLoading] = useState(true);

  const [jsonSearch, setJsonSearch] = useState("");

  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .getBoomScreenVerification(verificationId)
      .then((resp) => {
        setVerification(resp.data);
      })
      .catch((err) => {
        toast.error(
          "Error fetching verification details. Please try again later."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <AdminContainer variant="list">
      <Typography variant="h4">Verification details</Typography>

      <div className="flex items-center gap-2">
        <h1 className="text-2xl my-8 capitalize">
          {verification?.name?.replace("_", " ")}
        </h1>
        <VerificationStatusBadge status={verification?.status} />

        <Button
          variant="outlined"
          color="primary"
          onClick={() => setDrawerOpen(true)}
        >
          View JSON
        </Button>
        {verification?.name === "verified_income_verification" &&
          verification?.externalUrl && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.open(verification?.externalUrl, "_blank")}
            >
              Go to Ocrolus book
            </Button>
          )}
      </div>

      {loading ? (
        <div>
          <Typography variant="h6">Loading...</Typography>
        </div>
      ) : verification ? (
        <VerificationSwitch verification={verification} />
      ) : (
        <div className="flex justify-center items-center h-full">
          No verification data available.
        </div>
      )}

      {/* Side Drawer for JSON */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          height: "100vh",
          width: "800px",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "800px",
            boxSizing: "border-box"
          }
        }}
      >
        <Box p={2}>
          <Typography variant="h6" gutterBottom>
            Full JSON Response
          </Typography>
          <TextField
            label="Search"
            variant="outlined"
            size="small"
            placeholder="Search by key/value"
            fullWidth
            value={jsonSearch}
            onChange={(e) => setJsonSearch(e.target.value)}
          />

          <Box
            sx={{
              maxHeight: "80vh",
              overflowY: "auto",
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word"
            }}
          >
            <JsonEditor
              searchFilter="all"
              restrictAdd
              restrictEdit
              restrictDelete
              indent={2}
              searchText={jsonSearch}
              collapseAnimationTime={10}
              maxWidth="780px"
              restrictDrag
              data={verification?.data}
            />
          </Box>
        </Box>
      </Drawer>
    </AdminContainer>
  );
};
